export enum RowModelTypeEnum {
	ClientSide = 'clientSide',
	Infinite = 'infinite',
}
